import React, { useState, useRef } from 'react'
import Cropper from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { UploadOutlined } from '@ant-design/icons'
import { useTranslation } from 'src/utils/i18n'
import Tesseract from 'tesseract.js'

import { Upload, message, Button } from 'antd'

const ImageCropper = ({ onTextChange }) => {
  // 1. 创建状态
  const [src, setSrc] = useState(null)
  const [crop, setCrop] = useState({ unit: 'px', width: 100, height: 100 })
  const [image, setImage] = useState(null)
  const [cutImage, setCutImage] = useState('')
  const [text, setText] = useState('')
  const canvasRef = useRef(null)
  const { t } = useTranslation('androidLogin')

  // 2. 处理图片上传
  const handleFileChange = e => {
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.onloadend = () => {
      setSrc(reader.result)
    }
    reader.readAsDataURL(file)
  }

  // 3. 读取并显示图片预览
  const handleImageLoaded = image => {
    setImage(image)
  }

  // 4. 初始化裁剪组件
  const handleCropChange = newCrop => {
    setCrop(newCrop)
  }

  // 5. 配置裁剪参数
  const handleCropComplete = crop => {
    if (image && crop.width && crop.height) {
      const canvas = canvasRef.current
      const ctx = canvas.getContext('2d')
      const scaleX = image.naturalWidth / image.width
      const scaleY = image.naturalHeight / image.height
      canvas.width = crop.width
      canvas.height = crop.height
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      )

      // 异步处理 OCR 识别
      setTimeout(() => {
        const croppedImage = canvas.toDataURL('image/png')
        setCutImage(croppedImage)
        Tesseract.recognize(croppedImage, 'eng', {
          logger: info => console.log(info)
        })

          .then(({ data: { text } }) => {
            setText(text)
            onTextChange(text)
          })
          .catch(err => {
            console.error('OCR 错误:', err)
          })
      }, 100)
    }
  }

  return (
    <div className='flex flex-col'>
      {/* 2. 创建上传图片的功能 */}
      <Upload
        accept='image/*'
        showUploadList={false}
        customRequest={({ file }) => {
          // 处理文件上传
          handleFileChange({ target: { files: [file] } })
        }}
      >
        <Button icon={<UploadOutlined />}>{t('Upload photo to identify number')}</Button>
      </Upload>
      {/* 3. 读取并显示图片预览 */}
      <div className='flex w-full justify-center items-center mt-2'>
        {src && (
          <Cropper
            src={src}
            crop={crop}
            zoomable={true}
            viewMode={1}
            onChange={handleCropChange}
            onImageLoaded={handleImageLoaded}
            onComplete={handleCropComplete}
          />
        )}
      </div>
      {/* 7. 生成裁剪后的图片数据 */}
      <canvas ref={canvasRef} style={{ display: 'none' }} />
    </div>
  )
}

export default ImageCropper
